<!--begin::Modal Error-->
<div class="modal fade" id="m_modal_Error" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" style="min-width:600px;">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header" style="background-color: red;">
        <h5 class="modal-title" id="exampleModalLabel" style="font-size: 16px;color: white;">
         
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">
            &times;
          </span>
        </button>
      </div>
      <div class="modal-body">
        <!--begin::Form-->
        <ngx-json-viewer [json]="_JsonObject" style="font-size:16px" class="gridText" [expanded]="false"></ngx-json-viewer>
      
        <br />
        <!--end::Form-->
      </div>
      <div class="modal-footer">
        <button type="button" #CloseButton class="btn btn-danger" data-dismiss="modal">
          <i class="la la-close"></i>
          Kapat <small style="color:white;">(Esc)</small>
        </button>
      </div>
    </div>
  </div>
</div>

<button id="ErrorModalButton" [hidden]="true" style="visibility: hidden;" data-toggle="modal" data-target="#m_modal_Error"></button>

<!--end::Modal Error-->
